<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .checkbox-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: utils.in_rem(8px);
  }

  .tooltip-text {
    max-width: utils.in_rem(200px);
  }
</style>

<script>
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import Checkbox from "@sourcewhale/shared/src/svelte/src/components/legacy/Checkbox.svelte";

  export let checked = false;
  export let disabled = false;
  export let onChange;
  export let isMandatoryRelated = false;

  // Track previous checked state to detect changes
  let previousChecked = checked;

  // Watch for changes to the checked state, but only if the value is defined
  $: if (checked !== previousChecked && checked !== undefined) {
    previousChecked = checked;

    // Call the onChange handler when the checked state changes
    if (onChange) {
      onChange();
    }
  }
</script>

<div class="checkbox-cell">
  {#if disabled && isMandatoryRelated}
    <Tooltip
      placement="top"
      let:onmouseenter
      let:onmouseleave
      let:onfocus
      let:onblur
    >
      <span slot="tooltip" class="tooltip-text">
        Mandatory fields must be displayed. Deselect the mandatory field to
        disable this.
      </span>
      <div
        role="button"
        tabindex="0"
        on:mouseenter={onmouseenter}
        on:mouseleave={onmouseleave}
        on:focus={onfocus}
        on:blur={onblur}
      >
        <Checkbox bind:checked {disabled} />
      </div>
    </Tooltip>
  {:else}
    <Checkbox bind:checked {disabled} />
  {/if}
</div>
